export default "__VITE_ASSET__B78qDVZy__"